export default {
  weatherReport: {
    title: "Tempo",
    labels: {
      forecastUnavailable: "Previsão indisponível",
      unavailableDescription: "Previsão do tempo indisponível para este jogo.",
      unavailableValue: "N/A",
    },
    empty: {
      title: "Nenhum relatório do tempo disponível",
    },
  },
};
